import type { AdvancedOptions, MappingState } from '../../types';
import {
	transformMappingStateToFieldMapping,
	transformMappingStateToIssueLinkMapping,
	transformToDateProperties,
} from '../index';
import type { ValidateImportPayload } from './types';

export const getSiteUrl = () => `https://${window.location.hostname}`;

export const transformToValidateImportPayload = (
	mappingState: MappingState,
	advancedOptions: AdvancedOptions,
	isIssueLinkingAllowed: Boolean = false,
): ValidateImportPayload => ({
	fileEncoding: advancedOptions.fileEncoding,
	delimiter: advancedOptions.delimiter,
	dateProperties: transformToDateProperties(advancedOptions),
	columns: transformMappingStateToFieldMapping(mappingState),
	...(isIssueLinkingAllowed && {
		issueLinkColumns: transformMappingStateToIssueLinkMapping(mappingState),
	}),
});

export const transformToValidateUserImportPayload = (
	mappingState: MappingState,
	advancedOptions: AdvancedOptions,
	hasConfigFile: boolean,
) => ({
	fileEncoding: advancedOptions.fileEncoding,
	delimiter: advancedOptions.delimiter,
	columns: transformMappingStateToFieldMapping(mappingState),
	hasConfigFile,
});
